module.exports = __webpack_public_path__ + "assets/img/27_1168_big.5d7d63c5.jpg";